import { Portrait } from '@galaxy/lorule-react-commons';
import React, { useMemo } from 'react';
import { Column } from 'react-table';
import { Distribution } from '../../../api/actionMemoApiTypes';
import DataGrid from '../../common/datatables/DataGrid';

interface ViewersProps {
    viewers: Distribution[];
}

const Viewers = (props: ViewersProps) => {
    const { viewers } = props;

    const columns = useMemo(
        () => [
            {
                Header: '',
                accessor: 'distributionEmailAddress',
                Cell: (cellProps: { value: string }) =>
                    useMemo(
                        () => (
                            <div className="profile-photo">
                                <Portrait username={cellProps.value} roundedCircle />
                            </div>
                        ),
                        [],
                    ),
                disableSortBy: true,
                xs: 3,
                sm: 3,
                xl: 2,
            },
            {
                Header: 'Name / Title',
                accessor: 'distributionName',
                Cell: (cellProps: {
                    value: string;
                    row: {
                        original: {
                            distributionTitle: string;
                        };
                    };
                }) =>
                    useMemo(
                        () => (
                            <>
                                <div>{cellProps.value}</div>
                                <div className="font-italic font-weight-light">
                                    <small>{cellProps.row.original.distributionTitle}</small>
                                </div>
                            </>
                        ),
                        [],
                    ),
                xs: 9,
                sm: 9,
                xl: 6,
            },
            {
                Header: 'Role',
                accessor: 'projectRoleMeaning',
                xs: 12,
                sm: 6,
                xl: 4,
            },
        ],
        [],
    );

    return (
        <div className="react-table px-2">
            <DataGrid
                columns={columns as Column<Object>[]}
                data={viewers}
                noGlobalFilter
                noPagination
                initialState={{ pageSize: 1000 }}
                mobileShowList
            />
        </div>
    );
};

export default Viewers;
